import Header from './components/Header';
import Briefs from './components/Briefs';
import ShiftList from './components/ShiftList';
import useScreenSize from '../../../../hooks/useScreenSize';

function DailyBrief() {
  const screenSize = useScreenSize();
  const isLarge = screenSize == 'xl' || screenSize == '2xl';

  return (
    <div
      className={`h-full ${
        isLarge &&
        'rounded-tl-[32px] rounded-tr-[32px] rounded-bl-[32px] rounded-br-[32px]'
      } flex flex-col`}>
      <Header />

      <div className="flex-1 min-h-0 overflow-y-auto flex flex-col bg-[#F2F4F4]">
        <Briefs />
      </div>

      <ShiftList />
    </div>
  );
}

export default DailyBrief;
